export interface UiState {
    sidebarState: boolean;
    treeviewState: Array<string>;
    log: Array<LogMessage>;
}

export interface LogMessage {
    logLevel: number;
    timestamp: number;
    message: string;
}

export default {
    namespaced: true,
    state: (): UiState => ({
        sidebarState: false,
        treeviewState: [],
        log: [],
    }),
    mutations: {
        setSidebarState(state, value) {
            state.sidebarState = value;
        },
        triggerSidebarState(state) {
            state.sidebarState = !state.sidebarState;
        },
        setTreeviewState(state, value) {
            state.treeviewState = value;
        },
        logMessage(state, { logLevel, message }) {
            state.log.push({ logLevel, timestamp: Date.now(), message });
        },
        log(state, message) {
            state.log.push({ logLevel: 4, timestamp: Date.now(), message });
        },
        error(state, message) {
            state.log.push({ logLevel: 0, timestamp: Date.now(), message });
        },
        warn(state, message) {
            state.log.push({ logLevel: 1, timestamp: Date.now(), message });
        },
    },
    actions: {},
    modules: {},
};
